import React from 'react'
import {
  NavigationTileWrapper,
  NavigationTileAnchor,
  NavigationTileLabel
} from './NavigationTileStyledComponents'
import PropTypes from 'prop-types'

function NavigationTile ({ Icon, text, link }) {
  const isExternal = /^https?:\/\//.test(link)
  const content = (
    <>
      <Icon />
      <NavigationTileLabel>{text}</NavigationTileLabel>
    </>
  )

  if (isExternal) {
    return (
      <NavigationTileAnchor href={link} target="_blank" rel="noopener noreferrer">
        {content}
      </NavigationTileAnchor>
    )
  }

  return (
    <NavigationTileWrapper to={link}>
      {content}
    </NavigationTileWrapper>
  )
}

NavigationTile.displayName = 'NavigationTile'

NavigationTile.propTypes = {
  text: PropTypes.string,
  link: PropTypes.string.isRequired,
  Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired
}

export default NavigationTile
